var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWishlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.585 3.223a4.299 4.299 0 00-.949-1.37A4.453 4.453 0 0010.53.6a4.478 4.478 0 00-2.795.978A4.478 4.478 0 004.94.6a4.453 4.453 0 00-3.107 1.254c-.404.39-.726.855-.949 1.37a4.213 4.213 0 00-.35 1.684c0 .551.114 1.125.339 1.709.188.488.458.994.803 1.505.547.809 1.299 1.652 2.232 2.507a24.93 24.93 0 003.144 2.437l.395.25c.175.112.4.112.575 0l.395-.25a25.244 25.244 0 003.144-2.437c.933-.855 1.685-1.698 2.231-2.507a7.537 7.537 0 00.804-1.505 4.752 4.752 0 00.338-1.709 4.182 4.182 0 00-.348-1.685z",
    fill: "#FF8585"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.9930e7e0.svg";
export { ForwardRef as ReactComponent };